export default {
  'enabled-locations-map': {
    locations: 'Posizioni',
    'find-my-location': 'Trova la mia posizione',
    'select-country': 'Seleziona il paese',
    'all-countries': 'Tutti i paesi',
    search: 'Cerca',
    filter: 'Filtra per fornitore, città, paese o stato',
    'location-type': 'Tipo di posizione',
    '100G-enabled': 'Abilitato 100G',
    'local-ix-available': 'IX locale disponibile',
    'mcr-enabled': 'Abilitato MCR',
    'mve-enabled': 'Abilitato MVE',
    'view-latency': 'Visualizza latenza',
    'enquire-about-this-location': 'Richiedi informazioni su questa posizione',
    'enabled-location': 'Posizione abilitata',
    'extended-location': 'Posizione estesa',
    'loading-locations': 'Caricamento delle posizioni',
    'no-location-found': 'Nessuna posizione soddisfa i criteri del filtro',
    'closest-mp-enabled-location': 'La posizione abilitata Megaport più vicina è',
    'location-filter': 'Filtro delle posizioni',
    'coming-soon': 'Prossimamente',
    'enter-your-address': 'Inserisci il tuo indirizzo',
    'learn-about-enabled-extended-locations': 'Scopri di più sulle nostre Posizioni Abilitate e Estese',
    'megaport-supported-location-types': 'Megaport supporta due tipi di posizioni in cui puoi accedere alla nostra rete',
    'locations-by-distance': 'Posizioni per distanza',
    'map-showing-data-center-location': 'Mappa che mostra la posizione del data center',
  },
}
  
